<template>
  <div class="btn-dialog">
    <!-- 开始出价 -->
    <my-dialog
      width="446"
      :show="priceShow"
      title="出价"
      :close-fun="() => (priceShow = false)"
      top="20vh"
    >
      <div class="content" slot="content">
        <el-form
          ref="form"
          :model="dialogFrom"
          label-position="left"
          label-suffix="："
          label-width="80px"
        >
          <el-form-item class="form-price" label="买家出价">
            <el-input
              v-model.trim="dialogFrom.input_price"
              maxlength="7"
              placeholder="请输入出价金额"
            ></el-input>
            <div class="percent">为原价的{{ percent }}</div>
          </el-form-item>
          <div class="price-bottom">
            <div v-if="rowData.new_reserve_price">
              <span class="label">当前底价</span>
              <span class="price-origin">¥{{ rowData.new_reserve_price }}</span>
            </div>
            <div>
              <span class="label">商品原价：</span>
              <span class="price-origin">¥{{ rowData.product_price }}</span>
            </div>
          </div>
        </el-form>
      </div>
      <template slot="btn">
        <el-button :disabled="disabled" v-preventReClick='1000' class="btn-pay btn-long" @click="initiate">
          确认发起
        </el-button>
      </template>
    </my-dialog>
    <!-- 放弃提示   出价提示  告知书   验号结果-->
    <my-dialog
      :show="commonDialog"
      :title="dialogObj.title"
      :text="dialogObj.text"
      :close-fun="() => (commonDialog = false)"
      top="20vh"
      width="422"
    >
      <template slot="btn">
        <div class="footer-btn">
          <el-button
            class="btn-price w-140"
            @click="commonDialog = false"
            v-if="dialogObj.show_cancel"
            >取消</el-button
          >
          <el-button
           :disabled="disabled" v-preventReClick='1000'
            :class="[
              'btn-pay',
              openType !== 'bid' &&
              openType !== 'abandon_bargin' &&
              openType !== 'give_up' &&
              openType !== 'agree'
                ? 'w-192'
                : 'w-140',
            ]"
            @click="goConfirm"
            >{{ dialogObj.confirm_text }}</el-button
          >
        </div>
      </template>
    </my-dialog>
    <!-- 出价成功 -->
    <my-dialog top="20vh" :show="bidShow" :close-fun="closeBidSuccess">
      <template slot="content">
        <img class="bid-img" src="@/assets/image/bargin/success.png" alt="" />
        <div class="bid-res">出价成功</div>
        <div class="bid-tips">我们将快马加鞭送达卖家，请您静候佳音</div>
      </template>
      <div slot="btn" class="footer-btn">
        <el-button :disabled="disabled" v-preventReClick='1000' class="btn-pay w-225" @click="closeBidSuccess"
          >返回（{{ second }}S）</el-button
        >
      </div>
    </my-dialog>
    <!-- 申请验号 -->
    <my-dialog
      width="453"
      :show="applyShow"
      :close-fun="() => (applyShow = false)"
      :btnFuc="checkAcount"
      title="我要验号"
      btnText="发起验号"
      custom-class="tipDialog check-dialog"
      top="20vh"
    >
      <template slot="content">
        <div class="check">
          <div class="order">
            <img :src="rowData.image" alt="" />
            <div class="right-part">
              <div class="order-title">{{ rowData.product_name }}</div>
              <div class="order-tag">
                <span v-for="item in rowData.category_info" :key="item.value">{{
                  item.value
                }}</span>
              </div>
              <div class="order-price">
                <span class="suffix">¥</span>
                <span class="number">{{ rowData.product_price }}</span>
              </div>
            </div>
          </div>
          <my-progress
            :rowData="rowData"
            showWave
            :showLabel="false"
          ></my-progress>
          <div class="check-remark">
            <div class="remark">
              <span class="require">*</span>
              验号备注
            </div>
            <el-input
              v-model="remark"
              placeholder="如果有需要特别验证的内容请备注告知"
              type="textarea"
              show-word-limit
              :maxlength="300"
              :rows="4"
              :autosize="{ minRows: 4, maxRows: 7 }"
              resize="none"
            ></el-input>
          </div>
        </div>
      </template>
    </my-dialog>
    <!-- 验号报告 -->
    <verification-report
      ref="report"
      :id="id"
      :show.sync="reportShow"
      :showBtn="
        !(rowData.check_status === 5 || rowData.check_status === 6) &&
        rowData.status === 0
      "
      :reportData="reportData"
      v-bind="$props"
      clientType="buyer"
    ></verification-report>
  </div>
</template>

<script>
import myDialog from "@/components/myDialog.vue";
import verificationReport from "../../components/verificationReport.vue";
import Bus from "@/util/eventBus";
import myProgress from "@/components/myProgress";
import {
  earnestBargin,
  earnestGiveUp,
  applyVerify,
  verifyReport,
  payPrepare,
} from "@/request/API";
export default {
  components: {
    myDialog,
    verificationReport,
    myProgress,
  },
  props: {
    showDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      priceShow: false,
      commonDialog: false,
      remark: "",
      rowData: {
        button_list: [],
      },
      bidShow: false,
      reportShow: false,
      applyShow: false,
      openType: "bid", // bid 出价提示    abandon_bargin  放弃议价  abandon_purchase 放弃购买   check_fail   验号未通过   notification  告知书
      // 表单相关
      dialogFrom: {
        input_price: "",
      },
      custom: "",
      second: 3, //倒计时
      timer: null,
      // 验号报告
      reportData: {},
      id: "",
      disabled:false
    };
  },
  created() {
    Bus.$on("btnOperation", (data, type) => {
      this.rowData = data;
      // give_up 未付定金放弃   bid 出价   floor 底价购买  apply_check 申请验号 check_res 验号结果    abandon_bargin 放弃议价   abandon_purchase 放弃购买 agree 同意   payRest 付尾款
      switch (type) {
        //未付定金放弃 放弃议价、购买、  同意
        case "abandon_bargin":
        case "abandon_purchase":
        case "give_up":
        case "agree":
          // 验号状态 0初始 1买家申请验号 2卖家发送账号密码 验号中 3官方验号完成 4官方验号失败 5买家验号成功 6买家验号失败
          if (
            data.check_status == 1 ||
            data.check_status == 2 ||
            data.check_status == 3
          ) {
            this.id = this.rowData.id;
            this.$refs.report.abandonShow = true;
          } else {
            this.openType = type;
            this.commonDialog = true;
          }
          break;
        case "payRest":
            this.openType = type;
            this.commonDialog = true;
          break;
        // 出价
        case "bid":
          this.priceShow = true;
          this.openType = "bid";
          break;
        // 申请验号
        case "apply_check":
          this.applyShow = true;
          break;
        // 验号结果
        case "check_res":
          //  check_status0初始 1买家申请验号 2卖家发送账号密码 验号中 3官方验号完成 4官方验号失败 5买家验号成功 6买家验号失败
          if (this.rowData.check_status === 4) {
            this.openType = "check_fail";
            this.commonDialog = true;
            return;
          }
          verifyReport({
            order_id: this.rowData.id,
          })
            .then((res) => {
              this.reportData = res.data;
              if (this.rowData.check_status === 3 && this.rowData.status === 0) {
                this.openType = "notification";
                this.commonDialog = true;
              } else {
                this.reportShow = true;
              }
            })
            .catch((err) => {
              this.$message({
                message: err.msg,
                customClass: "counteroffer-msg",
              });
            });
          break;
      }
    });
  },
  watch: {
    priceShow(val) {
      if (!val) {
        this.dialogFrom.input_price = "";
      }
    },
  },
  computed: {
    percent() {
      return this.dialogFrom.input_price
        ? (
            (this.dialogFrom.input_price / this.rowData.product_price) *
            100
          ).toFixed(2) + "%"
        : "";
    },
    dialogObj() {
      let obj = {};
      // bid 出价提示    abandon_bargin  放弃议价  abandon_purchase 放弃购买   check_fail   验号未通过   notification  告知书
      switch (this.openType) {
        case "bid":
          obj = {
            title: "温馨提示",
            text: `您当前出价${
              this.dialogFrom.input_price < this.rowData.new_reserve_price
                ? "低"
                : "高"
            }于卖家同意的底价，请确认是否继续出价～`,
            confirm_text: "确认",
            show_cancel: true,
          };
          break;
        case "give_up":
          obj = {
            title: "提示",
            text: `是否确认放弃当前议价？`,
            confirm_text: "确认",
            show_cancel: true,
          };
          break;
        case "agree":
          obj = {
            title: "议价成功",
            text: `您已接受卖家的议价,快去支付尾款吧~`,
            confirm_text: "付尾款",
            show_cancel: true,
          };
          break;
        case "abandon_bargin":
          obj = {
            title: "提示",
            text: `您的诚意买将在5分钟内原路退回，请注意查收！`,
            confirm_text: "确认",
            show_cancel: true,
          };
          break;
        case "abandon_purchase":
          obj = {
            title: "放弃购买",
            text: `是否确认放弃当前账号，全款金额将在2个工作日内原路退回～`,
            confirm_text: "确认放弃",
            show_cancel: false,
          };
          break;
        case "check_fail":
          obj = {
            title: "验号未通过",
            text: `<p>经过游严选专业验号审核，该账号内容与发布不符，为了保护您的合法权益，此验号结果将归为不通过。</p><p>我们将在2个工作日内为您进行全额退款。
很抱歉给您造成困扰！欢迎继续关注游严选的其他商品！</p>`,
            confirm_text: "我知道了",
            show_cancel: false,
          };
          break;
        case "notification":
          obj = {
            title: "告知书",
            text: `<div class="notification">
              <p>1.上架商品截图及文字仅作展示参考，不作为账号交易依据。由于商品截图里 的六桶金、点券、道具等会因日常消耗等原因发生变化，请您以交易时买卖 双方最终确认的截图、文字为准。</p>
              <p>2.如因您个人原因无法正常接收账号，由买类双方协商处理，未出协商一致结 果之前，平台不受理任何理由退款。</p>
              <p>3.如发生上号验证账号期间出现毁号，行骗等一切不利于账号的行为，需卖房 同意后方可退款，若出现纠纷，按买卖双方协商一致结果处理，平台不参与 判定责任。</p>
              <p>4.财付通（即QQ钱包）不影响账号安全性，因此不作为账号交易的的强制修 改条件。</p>
              <p>5.商品交易过程中请勿私自修改账号资料，以免造成锁定、冻结、无法登录等 账号异常情况，否则造成的损失须由您个人承担。</p>
              <p>6.交易过程中，请勿出现恶意辱骂客服与卖家的行为，提倡文明交易。否则， 平台有权限制您的账号权限，并视情节封禁账号。</p>
              <p>7.因虚拟物品交易特殊性，交易完成的订单不支持退換。</p>
              <p>8.为保障您的权益，商品交易须签署合同；如您选择不签署合同，订单成交后 将为您生成《交易证明》，但产生的风险由您自己承担。</p>
              <p class="tips">9.特别提醒：账号发生找回时，您须在七日内联系平台处理，逾期处理所造成的损失由您个人承担。</p>
              <p>(1)平台在处理周期（十五日）内追回账号，号主需无条件接受账号，如在 处理周期（十五日）内追回游戏账号，号主拒收账号将视为默认放弃包 赔增值服务（若有)，如号主选择自己维权，平台提供辅助配合，而非主 导。</p>
              <p>(2)全额包赔增值服务、双倍包赔增值服务、三倍包赔增值服务等有偿服务 均没有时间限制，只要账号购买后未转手，都可无条件享受所对应的增 值服务，若买家谎称账号被找回或隐瞒账号已转手的情形，则所享有的 增值服务立即失效，并按诈骗处理。</p>
              <p>(3)找回包赔增值服务仅针对于“账号找回”行为生效，请您妥善保管自己 购买的游戏账号，找回包赔增值服务不对盗号、骗号、封号、冻结的情 形生效。</p>
              <p>(4)卖家个人承诺的情形，平台不承担费任，出现任何风险由您自己承担（包 括但不限于人脸验证）。</p>
              </div>`,
            confirm_text: "我知道了",
            show_cancel: false,
          };
          break;
        case "payRest":
        obj = {
            title: "买家须知",
            text: `<div class="payRest-wrapper">
            <div class="item">
              <div class="title">交易必看</div>
              <div class="pay-text">
                <span>1.卖家</span>
                <span class="color-FFB20C">在游严选平台出售游戏账号必须签署电子合同</span>
                <span>才能进行放款（签署合同时需要提供相关个人信息材料，包括但不限于：身份信息）。友情提醒：支付宝账号到账较快，微信、银行卡到账较慢。</span>
              </div>
              <div class="pay-text">
                <span>2.</span>
                <span class="color-FFB20C">出售游戏账号发生恶意找回，游严选游戏服务网有权提供相关资料，协助有关部门追回损失；</span>
                <span>若非您本人找回情形您有义务联系前任号主，若您拒绝配合将按本人找回处理；若您能提供有效的首任卖家具体信息与交易凭证（包括但不限于卖家收款记录，订单详情，聊天记录），平台未追回产生的损失与您无关。</span>
              </div>
              <div class="pay-text">
                <span>3.买家下单进行</span>
                <span class="color-FFB20C">账号交易时需支付全额价款，不接受预定金或口头预留等方式。</span>
              </div>
              <div class="pay-text">
                <span>4.交易过程中，请勿出现恶意辱骂，恶意行骗、引导站外等现象，否则，平台有权限制您的账号权限，并视情况封禁账号。</span>
              </div>
              <div class="pay-text">
                <span>5.交易前有任何疑问,请提前咨询客服,</span>
                <span class="color-FFB20C">开始交易即视为认同游严选游戏服务平台所有规则,最终解释权归金华市博淳网络科技有限公司所有。</span>
              </div>
            </div>
            <div class="item">
              <div class="title">交易须知</div>
              <div>
                <span class="tip">
                  <span>注</span>
                  确认验号无误后即为确认交易进入换绑阶段
                </span>
              </div>
              <div class="pay-text">
                <span>1.</span>
                <span class="color-FFB20C">验号无误前双方都可无责取消，确认验号无误后即为确认交易不接受任何理由取消</span>
                <span>，若因个人原因取消交易，需支付订单金额5%违约金，守约方、平台各半收取。 </span>
              </div>
              <div>
                <span class="tip">
                  PS:若卖家违约，拒不支付违约金，将对该账号及该用户多平台拉黑下架。
                </span>
              </div>
              <div class="pay-text">
                <span>2.</span>
                <span class="color-FFB20C">账号进入换绑交接验证码及进入审核后（包含游戏换绑审核期，挂IP等情况），不接受单方面赔付违约金取消，需买卖双方协商处理</span>
                <span>，平台不参与判定责任，最终处理以双方协商一致结果为准，若因游戏厂商原因首次换绑失败，买卖双方需配合平台引导进行账号交付，以顺利交付为主，若确实无法进行换绑交付，将按平台方案进行取消订单。</span>
              </div>
              <div class="pay-text">
                <span>3.</span>
                <span class="color-FFB20C">下单后订单（账号换绑审核期、挂IP等情况除外）理论交易时长为24小时内</span>
                <span>，（具体等待交易时长可由双方协定），如双方无法协定一致将按平台判定方案进行，</span>
                <span class="color-FFB20C">需要在等待交易时长内回应配合交付。如超出理论时长或协定时长，按违约处理。</span>
              </div>
              <div class="pay-text">
                <span>4.交易期间发现黑号记录，经证实后，可取消交易，各方均不承担任何责任。</span>
              </div>
              <div class="pay-text">
                <span class="color-FFB20C">5.交易期间出现毁号，行骗等一切不利于账号的行为，属于侵权行为，若出现纠纷，按买卖双方协商一致结果处理，无法达成一致可通过司法介入，平台配合协助处理，不参与判定责任。</span>
              </div>
              <div class="pay-text">
                <span>6.双方个人承诺等情形，不在平台担保范围之内请理性判断，出现任何风险与损失由您自己承担 ，平台只针对账号找回，人脸包赔等增值业务进行担保。</span>
              </div>
            </div>
            <div class="item">
              <div class="title">买家须知</div>
              <div class="pay-text">
                <span>1.如您个人原因不具备验号条件或换绑条件，先由买卖双方协商处理，如双方无法协定一致将按平台判定方案进行。</span>
              </div>
              <div class="pay-text">
                <span>2.商品</span>
                <span class="color-FFB20C">交易过程中请勿私自修改账号资料，以免造成锁定、冻结无法登录等账号异常情况，否则造成的损失须由您个人承担。</span>
              </div>
              <div class="pay-text">
                <span>3.账号</span>
                <span class="color-FFB20C">交易期间及换绑完成后24小时内建议您不要对该账号进行任何形式的充值消费及消耗道具资源等，否则引起的一切纠纷由您自己承担。</span>
              </div>
              <div class="pay-text">
                <span>4.因虚拟物品交易特殊性，交易完成的订单不支持退换。</span>
              </div>
              <div class="pay-text">
                <span>5.为保障您的权益，商品交易须签署合同，如您选择不签署合同或账号已完成交付情况下失联超出1小时，订单成交后将为您生成《交易证明》，但产生风险由您自己承担。</span>
              </div>
              <div class="pay-text">
                <span>6.卖家交付商品后，需要您及时确认收货。卖家交付后指定时间内买家未确认收货，系统将自动确认收货，后续若有损失或交易纠纷，由您自行承担。</span>
              </div>
              <div>
                <span class="tip">
                  <span>注</span>
                  本平台只为年满18周岁的成年人提供账号交易，如果您是未成年擅自使用成年家属身份交易的，视为成年家属自己的行为。
                </span>
              </div>
            </div>
          </div>`,
            confirm_text: "知道了",
            show_cancel: false,
          };
          break;
      }
      return obj;
    },
  },
  methods: {
    //  我要验号
    checkAcount() {
      if (!this.remark)
        return this.$message({
          message: "请输入验号备注",
          customClass: "counteroffer-msg",
        });
      applyVerify({
        order_id: this.rowData.id,
        remark: this.remark,
      })
        .then((res) => {
          this.$message.success("申请成功");
          this.applyShow = false;
          Bus.$emit("reFresh");
        })
        .catch((err) => {
          if (err?.code == 10001) {
            this.applyShow = false;
            Bus.$emit("reFresh");
          }
          this.$message({
            message: err.msg,
            customClass: "counteroffer-msg",
          });
        });
    },
    // 调用出价接口
    confirmBid() {
      earnestBargin({
        price: this.dialogFrom.input_price,
        order_id: this.rowData.id,
      })
        .then((res) => {
          this.bidShow = true;
          this.$nextTick(() => {
            this.countDown();
            this.commonDialog = false;
            this.priceShow = false;
          });
        })
        .catch((err) => {
          // 商品二次编辑   下架  改价 10012 跳详情页 10013 跳列表页
          if (err?.code === 10012 || err?.code === 10013) {
            Bus.$emit("productChange", {
              error_code: err.code,
              ...this.rowData,
            });
          }
          this.$message({
            message: err.msg,
            customClass: "counteroffer-msg",
          });
        });
    },
    // 确认发起议价
    initiate() {
      var reg = /^\d+$/;
      if (this.dialogFrom.input_price === "") {
        return this.$message({
          message: "请输入出价金额",
          customClass: "counteroffer-msg",
        });
      }
      if (!reg.test(this.dialogFrom.input_price)) {
        return this.$message({
          message: "议价金额不支持小数、负数和字符",
          customClass: "counteroffer-msg",
        });
      }
      if (
        (this.dialogFrom.input_price / this.rowData.product_price) * 100 <
        65
      ) {
        return this.$message({
          message: "金额不得低于商品价格的65%",
          customClass: "counteroffer-msg",
        });
      }
      if (this.dialogFrom.input_price > this.rowData.product_price) {
        return this.$message({
          message: "您的出价已超出原价，请重新出价！",
          customClass: "counteroffer-msg",
        });
      }
      this.$refs.form.validate((validate) => {
        if (validate) {
          // 有底价
          if (this.rowData.new_reserve_price) {
            this.rowData.new_reserve_price == this.dialogFrom.input_price
              ? this.confirmBid()
              : (this.commonDialog = true);
          } else {
            // 无底价
            this.confirmBid();
          }
        }
      });
    },
    countDown() {
      this.timer = setInterval(() => {
        this.second--;
        if (this.second == 0) {
          this.bidShow = false;
          Bus.$emit("reFresh");
          this.$nextTick(() => {
            this.second = 3;
          });
          clearInterval(this.timer);
        }
      }, 1000);
    },
    // 出价成功弹窗  --- 主动点击关闭
    closeBidSuccess() {
      this.bidShow = false;
      if (this.timer) clearTimeout(this.timer);
      Bus.$emit("reFresh");
    },
    openNewPage(name, type, data) {
      var query;
      // type 1账号  尾款   3诚意金
      switch (name) {
        case "MethodOfPayment":
          query = {
            type,
            id: data ? data.product_id : this.rowData.product_id,
            orderid: data ? data.product_order_id : this.rowData.id,
            gameid: data ? data.game_id : this.rowData.game_id,
            amount: data ? data.order_amount : this.rowData.earnest_amount,
            earnest_order_id: this.rowData.id,
          };
          break;
        case "OnlineDeal":
          query = {
            id: this.rowData.product_id,
            game_id: this.rowData.game_id,
            earnest_order_id: this.rowData.id,
          };
          break;
      }
      var { href } = this.$router.resolve({
        name: name,
        query,
      });
      window.open(href, "_blank");
    },
    // 确认议价二次确认
    goConfirm() {
      switch (this.openType) {
        //  议价
        // 有底价弹窗确认
        case "bid":
          this.confirmBid();
          break;
        // 告知书
        case "notification":
          this.reportShow = true;
          this.$nextTick(() => {
            this.commonDialog = false;
          });
          break;
        // 同意弹窗确认
        case "agree":
          this.commonDialog = false;
          // 订单选择包赔页
          var { href } = this.$router.resolve({
            name: "OnlineDeal",
            query: {
              id: this.rowData.product_id,
              game_id: this.rowData.game_id,
              earnest_order_id: this.rowData.id,
            },
          });
          window.open(href, "_blank");
          break;
        case "payRest":
          this.commonDialog = false;
          payPrepare({ order_id: this.rowData.id })
            .then((res) => {
              Bus.$emit("closeDialog");
              if (res.data.order_amount > 0) {
                this.openNewPage("MethodOfPayment", "1", res.data);
              } else {
                this.openNewPage("OnlineDeal");
              }
            })
            .catch((err) => {
              // 商品二次编辑   下架  改价 10012 跳详情页 10013 跳列表页
              if (err?.code === 10012 || err?.code === 10013) {
                Bus.$emit("productChange", {
                  error_code: err.code,
                  ...this.rowData,
                });
              }
              this.$message({
                message: err.msg,
                customClass: "counteroffer-msg",
              });
            });
          break;
        default:
          this.commonDialog = false;
          if (this.rowData.button_list.includes(19)) return;
          //放弃接口  time_out手动调用为0  超时调用为1
          earnestGiveUp({ order_id: this.rowData.id, time_out: 0 })
            .then((res) => {
              Bus.$emit("reFresh");
              res.data.give_up_msg
                ? this.$message({
                    message: res.data.give_up_msg,
                    customClass: "counteroffer-msg",
                  })
                : "";
            })
            .catch((err) => {
              // 商品二次编辑   下架  改价 10012 跳详情页 10013 跳列表页
              if (err?.code === 10012 || err?.code === 10013) {
                Bus.$emit("productChange", {
                  error_code: err.code,
                  ...this.rowData,
                });
              }
              this.$message({
                message: err.msg,
                customClass: "counteroffer-msg",
              });
            });
          break;
      }
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    Bus.$off(["btnOperation"]);
  },
};
</script>

<style lang="less" scoped>
.btn-dialog {
  font-family: PingFang SC;
  .el-button {
    min-width: 96px;
    height: 36px;
    color: var(--text-main, #1A1D24);
    font-size: 14px;
    font-weight: 500;
    padding: 0 18px;
    border-radius: 3px;
    border: 1.5px solid var(--bg-dark, #1A1D24);
    background: #FFFFFF;
    transition: color .2s ease, border-color .2s ease, box-shadow .2s ease, opacity .2s ease, background .2s ease;

    &:hover {
      border-color: var(--bg-dark, #1A1D24);
      box-shadow: 0 6px 14px rgba(26, 29, 36, 0.12);
    }

    &.btn-pay {
      border-color: transparent;
      color: #FFFFFF;
      background: var(--primary, #FF5A1F);
      box-shadow: 0 6px 14px rgba(255, 90, 31, 0.18);

      &:hover {
        border-color: transparent;
        background: var(--primary-hover, #E84A12);
      }
    }
    &.btn-price {
      color: var(--text-secondary, #5A5F6B);
      border: 1px solid var(--border-soft, #E8E4DE);
      background: #fff;
    }
  }
  /deep/.content {
    width: 100%;
    margin-top: 24px;
    .el-form-item {
      margin-bottom: 16px;
    }
    .form-price {
      position: relative;
      .el-form-item__label {
        color: var(--text-main, #111827);
        font-size: 15px;
        font-weight: 500;
        padding: unset;
        &::before {
          display: none;
        }
      }
      .percent {
        position: absolute;
        right: 30px;
        top: 0;
        color: var(--text-muted, #9AA0AC);
        font-weight: 400;
        font-size: 13px;
      }
      .el-input__inner {
        height: 40px;
        border-radius: 4px;
        border-color: var(--border-soft, #E8E4DE);
        color: var(--text-main, #111827);
      }
      .el-input__inner:focus {
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }
    }
    .price-bottom {
      margin-bottom: 28px;
      padding: 12px 14px;
      display: flex;
      justify-content: space-between;
      gap: 12px;
      background: var(--bg-tag, #F0EDE8);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      .price-origin {
        color: var(--primary, #FF5A1F);
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.32px;
      }
      .label {
        color: var(--text-secondary, #5A5F6B);
        font-weight: 400;
      }
    }
    .form-item {
      .el-form-item__label {
        color: #999;
        font-size: 16px;
        font-weight: 400;
        padding: unset;
      }
      .el-form-item__content {
        .label {
          color: #999;
          font-size: 16px;
          font-weight: 400;
          margin-left: 138px;
        }
        .el-form {
          float: right;
          .el-form-item__content {
            width: fit-content !important;
          }
        }
      }
    }
  }
  .footer-btn {
    .w-140 {
      width: 140px;
    }
    .w-225 {
      width: 225px;
    }
    .w-192 {
      width: 192px;
    }
    .el-button {
      font-size: 15px;
      font-weight: 500;
    }
  }
  .btn-long {
    width: 290px;
  }

  .bid-img {
    width: 64px;
    height: 64px;
  }
  .bid-res {
    font-size: 24px;
    font-weight: 500;
    color: var(--text-main, #111827);
    margin: 17px auto 10px;
  }
  .bid-tips {
    color: var(--text-secondary, #5A5F6B);
    font-weight: 400;
    letter-spacing: 0.5px;
    margin-bottom: 24px;
  }
  /deep/.check-dialog {
    .title {
      color: var(--text-main, #111827);
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      letter-spacing: 0.5px;
    }
    .check {
      padding-top: 30px;
      .order {
        display: flex;
        justify-content: space-between;
        padding: 12px;
        background: var(--bg-tag, #F0EDE8);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        img {
          width: 135px;
          height: 90px;
          margin-right: 15px;
          object-fit: cover;
          border-radius: 4px;
        }
        .right-part {
          width: calc(100% - 150px);
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        &-title {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          font-weight: 500;
          color: var(--text-main, #111827);
          letter-spacing: 0.28px;
          margin-top: 2px;
        }
        &-tag {
          margin: 5px 0 7px 0;
          color: var(--text-secondary, #5A5F6B);
          letter-spacing: 0.2px;
          font-weight: 400;
          font-size: 12px;
          transform: scale(0.85) translateX(-20px);
        }
        &-price {
          color: var(--text-main, #111827);
          .suffix {
            letter-spacing: 0.2px;
            font-weight: 400;
            font-size: 12px;
            transform: scale(0.85);
          }
          .number {
            letter-spacing: 0.32px;
            font-family: DIN OT;
            font-size: 16px;
            font-weight: 700;
            margin-left: 2px;
          }
        }
      }
      .progress {
        height: 80px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .check-remark {
        background: var(--bg-tag, #F0EDE8);
        padding: 10px 20px;
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        margin-bottom: 30px;
        .remark {
          background: transparent;
          font-weight: 500;
          letter-spacing: 0.28px;
          color: var(--text-main, #111827);
          line-height: 20px;
          .require {
            color: var(--hot, #FF2D55);
            letter-spacing: 0.28px;
            font-weight: 500;
          }
        }
        .el-textarea__inner {
          border: none;
          background: transparent;
          padding-left: 0;
          .font() {
            font-size: 12px;
            color: var(--text-muted, #9AA0AC);
            font-weight: 400;
            letter-spacing: 0.24px;
            line-height: 20px;
          }
          &::-webkit-input-placeholder {
            /* 使用webkit内核的浏览器 */
            .font();
          }
          &:-moz-placeholder {
            /* Firefox版本4-18 */
            .font();
          }
          &::-moz-placeholder {
            /* Firefox版本19+ */
            .font();
          }
          &:-ms-input-placeholder {
            /* IE浏览器 */
            .font();
          }
        }
        .el-input__count {
          background: transparent;
        }
      }
    }
  }
  /deep/.floor-dialog {
    #tipDialog {
      overflow: hidden;
      background: url("~@/assets/image/bargin/floor-title.png") no-repeat;
      background-size: 100% 128px;
      img {
        width: 153px;
        height: 112px;
        margin: 25px;
      }
      .progress {
        height: auto;
        width: 100%;
      }
      .close {
        display: none;
      }
      .create-order {
        font-weight: 400;
        color: #f08c2b;
        line-height: 26px;
        height: 26px;
      }
    }
  }
}
</style>
<style lang="less">
.text {
  width: auto !important;
  .notification {
    max-height: 358px;
    overflow: auto;
    width: 354px;
    padding: 0 25px;
    &::-webkit-scrollbar {
      width: 4px; /* 滚动条宽度 */
      height: 4px;
    }

    &::-webkit-scrollbar-track {
      // background-color: #f1f1f1; /* 滚动条背景色 */
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(26, 29, 36, 0.28); /* 滚动条滑块颜色 */
      border-radius: 4px;
    }
    .text-indent{
      text-indent: 2rem;
    }
  }
  p {
    text-align: left;
    margin: 0;
    color: var(--text-secondary, #5A5F6B);
    letter-spacing: 0.08px;
    font-size: 14px;
    font-weight: 400;
    line-height: 170%;
  }
  .tips {
    color: var(--text-main, #1A1D24);
  }
  .payRest-wrapper{
    margin: 21px 0 12px;
    max-height: 362px;
    overflow: auto;
    .item{
      display: flex;
      flex-direction: column;
      margin: 0 0 19px;
      .title{
        font-size: 16px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: var(--text-main, #111827);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 4px;
        &::before{
            content: '';
            display: block;
            background: var(--primary, #FF5A1F);
            width: 4px;
            height: 15px;
            border-radius: 4px;
            margin-right: 6px;
        }
      }
      .pay-text {
        font-size: 14px;
        font-family: PingFang SC-Light, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        line-height: 22px;
        margin: 4px 0;
        text-align: left;
        .color-FFB20C{
          color: var(--primary, #FF7A1A);
        }
      }
      .tip{
        display: inline-block;
        line-height: 26px;
        padding: 0 10px;
        // height: 26px;
        background: var(--bg-tag, #F0EDE8);
        border-radius: 4px;
        color: var(--text-main, #1A1D24);
        text-align: left;
        span{
          display: inline-block;
          font-size: 12px;
          color: #fff;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: var(--bg-dark, #1A1D24);
          line-height: 22px;
          text-align: center;
          transform: scale(0.8);
        }
      }
    }

    .item:last-of-type{
      margin: 0;
    }

    &::-webkit-scrollbar-track {
      border-radius: 4px;
      background: transparent;
    }

    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(0, 0, 0, 0.2);
    }
  }
}

.counteroffer-msg {
  border-radius: 4px;
  background: #fcf0f0;
  padding: 10px 43px;
  z-index: 9999999;
  .el-message__icon {
    display: none;
  }
  .el-message__content {
    color: #e47470;
    text-align: center;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
  }
}
</style>
